import phraseSelectionAlert from "./phrase_selection_alert";

class Transcript {
  constructor(transcriptContainer, transcriptType, url, highlightWords = [], isMobileDevice, playerService, popoverService, translationService, learnedWords = [], savedWords = []) {
    this.transcriptContainer = transcriptContainer;
    this.transcriptType = transcriptType;
    this.url = url;
    this.jsonData = null;
    this.eventHandlers = {};
    this.highlightWords = highlightWords;
    this.learnedWords = learnedWords;
    this.savedWords = savedWords;
    this.isMobileDevice = isMobileDevice;

    this.playerService = playerService;
    this.popoverService = popoverService;
    this.translationService = translationService;
    this.isSelecting = false;
    this.isDragging = false;
  }

  // Register an event handler
  on(event, handler) {
    if (!this.eventHandlers[event]) {
      this.eventHandlers[event] = [];
    }
    this.eventHandlers[event].push(handler);
  }

  // Trigger an event
  trigger(event, ...args) {
    if (this.eventHandlers[event]) {
      this.eventHandlers[event].forEach(handler => handler(...args));
    }
  }

  async setup() {
    try {
      if (this.transcriptType === 'json') {
        await this.fetchAndDisplayJSON();
      } else if (this.transcriptType === 'vtt') {
        await this.fetchAndDisplayVTT();
      }
      // Trigger the ready event
      this.trigger('ready');
    } catch (error) {
      console.error('Error in setup:', error);
    }
  }

  setupEventListeners() {
    this.transcriptContainer.addEventListener('scroll', function () {
      const activeTranslatedWord = document.getElementsByClassName('active')[0]
      if (activeTranslatedWord && this.isElementOutOfView(activeTranslatedWord)) {
        $(`#${activeTranslatedWord.id}`).popover('hide')
      } else if (activeTranslatedWord && !this.isElementOutOfView(activeTranslatedWord)) {
        $(`#${activeTranslatedWord.id}`).popover('show')
      }
    })
  }

  async fetchAndDisplayJSON() {
    try {

      // load skeleton on vtt container
      this.transcriptContainer.innerHTML = `
<div class="skeleton skeleton-text mt-2"></div> <div class="skeleton skeleton-text"></div>
<div class="skeleton skeleton-text mt-2"></div> <div class="skeleton skeleton-text"></div>
<div class="skeleton skeleton-text mt-2"></div> <div class="skeleton skeleton-text"></div>
<div class="skeleton skeleton-text mt-2"></div> <div class="skeleton skeleton-text"></div>
<div class="skeleton skeleton-text mt-2"></div> <div class="skeleton skeleton-text"></div>
`;

      const response = await fetch(this.url);
      const content = await response.text();

      this.transcriptContainer.innerHTML = '';

      // fix for json.parse error
      this.jsonData = JSON.parse(content.replace(/\bNaN\b/g, "null"));

      this.displaySegments();
    } catch (error) {
      console.error('Error fetching JSON file:', error);
    }
  }

  // display vtt file
  async fetchAndDisplayVTT() {
    try {

      // load skeleton on vtt container
      this.transcriptContainer.innerHTML = `
<div class="skeleton skeleton-text mt-2"></div> <div class="skeleton skeleton-text"></div>
<div class="skeleton skeleton-text mt-2"></div> <div class="skeleton skeleton-text"></div>
<div class="skeleton skeleton-text mt-2"></div> <div class="skeleton skeleton-text"></div>
<div class="skeleton skeleton-text mt-2"></div> <div class="skeleton skeleton-text"></div>
<div class="skeleton skeleton-text mt-2"></div> <div class="skeleton skeleton-text"></div>
`;

      import(/* webpackChunkName: "webvtt-parser" */ 'webvtt-parser').then((webvttModule) => {
        fetch(this.url)
          .then(response => response.text())
          .then(data => {
            const parser = new webvttModule.WebVTTParser()
            const cues = parser.parse(data).cues

            this.transcriptContainer.innerHTML = '';

            cues.forEach((cue, index) => {
              const segmentDiv = this.displaySegment(cue, index);

              let splitCue = cue.text.split(' ')
              splitCue.forEach((word, wordIndex) => {
                this.displayWord({
                  text: word,
                  start: cue.startTime,
                  end: cue.endTime
                }, wordIndex, index, segmentDiv);
              });

              this.transcriptContainer.appendChild(segmentDiv);
            })

            setupAudioSync();
          })
      })
    } catch (error) {
      console.error('Error fetching VTT file:', error);
    }
  }

  displaySegments() {
    if (this.jsonData.results) {
      // Deepgram format
      this.jsonData.results.channels[0].alternatives[0].paragraphs.paragraphs.forEach((paragraph, index) => {
        paragraph.sentences.forEach((segment, segmentIndex) => {
          const segmentDiv = this.displaySegment(segment, segmentIndex);

          segment.words.forEach((word, wordIndex) => {
            // if word start time is the same as the segment end time, skip
            if (word.start === segment.end) {
              return;
            }

            this.displayWord(word, wordIndex, segmentIndex, segmentDiv);
          });

          this.transcriptContainer.appendChild(segmentDiv);
        });

        this.transcriptContainer.appendChild(document.createElement('br'));
        this.transcriptContainer.appendChild(document.createElement('br'));
      });
    } else if (this.jsonData.segments && this.jsonData.segments.length > 0) {
      // Whisper format with segments array
      this.jsonData.segments.forEach((segment, segmentIndex) => {
        const segmentDiv = this.displaySegment(segment, segmentIndex);

        // Handle segments that may have words array or not
        if (segment.words && segment.words.length > 0) {
          segment.words.forEach((word, wordIndex) => {
            this.displayWord(word, wordIndex, segmentIndex, segmentDiv);
          });
        } else {
          // If no words array, create a single word span for the entire segment
          const wordSpan = document.createElement('span');
          wordSpan.textContent = `${segment.text} `;
          wordSpan.className = 'word';
          wordSpan.dataset.startTime = segment.start;
          wordSpan.dataset.endTime = segment.end;
          wordSpan.id = `word-${segmentIndex}-0`;
          
          wordSpan.addEventListener('click', (e) => {
            if (!wordSpan.classList.contains('challenge')) {
              e.stopPropagation();
              this.trigger('wordClick', wordSpan);
            }
          });

          segmentDiv.appendChild(wordSpan);
        }

        this.transcriptContainer.appendChild(segmentDiv);
        this.transcriptContainer.appendChild(document.createElement('br'));
        this.transcriptContainer.appendChild(document.createElement('br'));
      });
    } else if (this.jsonData.words) {
      // ElevenLabs format with flat words array
      this.displayElevenLabsTranscript();
    }
  }

  displayWord(word, wordIndex, segmentIndex, segmentDiv) {
    const wordSpan = document.createElement('span');
    // Handle different word formats: punctuated_word (Deepgram), text (Whisper), word (ElevenLabs)
    wordSpan.textContent = `${word.punctuated_word || word.text || word.word} `;
    wordSpan.className = 'word';
    wordSpan.dataset.startTime = word.start;
    wordSpan.dataset.endTime = word.end;
    wordSpan.id = `word-${segmentIndex}-${wordIndex}`;

    // Get the base word for highlighting (remove punctuation if needed)
    const baseWord = word.word || word.text || word.punctuated_word;
    
    if (baseWord && this.highlightWords.includes(baseWord)) {
      wordSpan.classList.add('highlighted-word');
    }

    if (baseWord && this.learnedWords.includes(baseWord)) {
      wordSpan.classList.add('learned-word');
    }

    if (baseWord && this.savedWords.includes(baseWord)) {
      wordSpan.classList.add('saved-word');
    }

    wordSpan.addEventListener('click', (e) => {
      if (!wordSpan.classList.contains('challenge')) {
        e.stopPropagation();

        this.trigger('wordClick', wordSpan);
      }
    });

    wordSpan.addEventListener('mousedown', (e) => {
      this.handlePhraseSelectStart()
    });

    wordSpan.addEventListener('mousemove', (e) => {
      this.handlePhraseSelect()
    });

    wordSpan.addEventListener('mouseup', (e) => {
      this.handlePhraseSelectEnd(e)
    });

    segmentDiv.appendChild(wordSpan);
  }

  handlePhraseSelectStart() {
    this.isSelecting = true;

    document.querySelectorAll('.phrase-end').forEach(word => {
      word.classList.remove('phrase-end');
    });
  }

  handlePhraseSelect() {
    if (this.isSelecting) {
      this.isDragging = true;
    }
  }

  handlePhraseSelectEnd(e) {
    if (this.isDragging) {
      e.target.classList.add('phrase-end');

      this.isSelecting = false;
      this.isDragging = false;

      e.stopPropagation();

      let selectedTextLength = window.getSelection().toString().replace(/\s+/g, '').length;

      if (selectedTextLength > 0 && selectedTextLength <= 70) {
        this.trigger('phraseSelected');
      } else {
        if (selectedTextLength > 70) {
          let phraseSelectionAlert = require('./phrase_selection_alert');

          phraseSelectionAlert();
        }
      }
    } else {
      this.isSelecting = false;
      this.isDragging = false;
    }
  }

  displaySegment(segment, segmentIndex) {
    const segmentDiv = document.createElement('span');
    segmentDiv.id = `segment-${segmentIndex + 1}`;
    segmentDiv.dataset.id = `${segment.id}`;
    segmentDiv.classList.add('unactive-sentence')

    if (segment.text) {
      segmentDiv.dataset.text = segment.text;
      segmentDiv.dataset.startTime = segment.start || segment.startTime;
      segmentDiv.dataset.endTime = segment.end || segment.endTime;
    }

    segmentDiv.addEventListener('click', () => {
      this.trigger('segmentClick', segmentDiv);
    })

    return segmentDiv;
  }

  isElementOutOfView(element) {
    const containerRect = this.transcriptContainer.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    let scrollThreshold;

    if (this.isMobileDevice) {
      scrollThreshold = 250;
    } else {
      scrollThreshold = 150;
    }

    if (
      elementRect.bottom < containerRect.top ||
      elementRect.top > (containerRect.bottom - scrollThreshold) ||
      elementRect.right < containerRect.left ||
      elementRect.left > containerRect.right
    ) {
      return true;
    }

    return false;
  }

  displayElevenLabsTranscript() {
    // Filter out spacing elements and create segments from words
    const words = this.jsonData.words.filter(w => w.type === 'word');
    
    if (words.length === 0) return;
    
    // Create segments by grouping words into natural paragraphs
    const segments = [];
    let currentSegment = {
      words: [],
      start: words[0].start,
      end: words[0].end,
      text: ''
    };
    
    let sentenceCount = 0;
    
    words.forEach((word, index) => {
      const nextWord = words[index + 1];
      const isEndOfSentence = word.text && (word.text.endsWith('.') || word.text.endsWith('?') || word.text.endsWith('!'));
      const isVeryLongPause = nextWord && (nextWord.start - word.end) > 3.0; // Only break on very long pauses (3+ seconds)
      
      // Add word to current segment
      currentSegment.words.push(word);
      currentSegment.text += word.text + ' ';
      currentSegment.end = word.end;
      
      // Track sentences for paragraph breaks
      if (isEndOfSentence) {
        sentenceCount++;
      }
      
      // Create new segment after 3-5 sentences or very long pause
      // This creates more natural paragraph-like segments
      const shouldBreak = (sentenceCount >= 3 && isEndOfSentence) || 
                         isVeryLongPause || 
                         index === words.length - 1 ||
                         currentSegment.words.length > 100; // Max 100 words per segment
      
      if (shouldBreak) {
        segments.push(currentSegment);
        sentenceCount = 0;
        
        if (index < words.length - 1) {
          currentSegment = {
            words: [],
            start: nextWord.start,
            end: nextWord.end,
            text: ''
          };
        }
      }
    });
    
    // Display the segments without excessive line breaks
    segments.forEach((segment, segmentIndex) => {
      const segmentDiv = this.displaySegment({
        id: segmentIndex,
        text: segment.text.trim(),
        start: segment.start,
        end: segment.end
      }, segmentIndex);
      
      segment.words.forEach((word, wordIndex) => {
        this.displayWord(word, wordIndex, segmentIndex, segmentDiv);
      });
      
      this.transcriptContainer.appendChild(segmentDiv);
      
      // Only add a single space between segments for readability
      // No double line breaks needed
      if (segmentIndex < segments.length - 1) {
        this.transcriptContainer.appendChild(document.createTextNode(' '));
      }
    });
  }

  extractSentenceContainingWord(wordElement) {
    // Get the parent segment element
    const segmentEl = wordElement.parentNode;
    if (!segmentEl) return wordElement.textContent;
    
    // Get all word elements in the segment
    const allWords = Array.from(segmentEl.querySelectorAll('.word'));
    const wordIndex = allWords.indexOf(wordElement);
    
    if (wordIndex === -1) return wordElement.textContent;
    
    // Define sentence endings for different languages
    const sentenceEndings = {
      // Latin-based languages
      default: ['.', '!', '?'],
      // Chinese
      zh: ['。', '！', '？', '.', '!', '?'],
      chinese: ['。', '！', '？', '.', '!', '?'],
      // Japanese
      ja: ['。', '！', '？', '.', '!', '?'],
      japanese: ['。', '！', '？', '.', '!', '?'],
      // Arabic
      ar: ['؟', '!', '.', '?'],
      arabic: ['؟', '!', '.', '?'],
      // Hindi
      hi: ['।', '!', '?', '.'],
      hindi: ['।', '!', '?', '.'],
      // Korean
      ko: ['.', '!', '?', '。', '！', '？'],
      korean: ['.', '!', '?', '。', '！', '？']
    };
    
    // Get the language from the transcript container
    const language = this.transcriptContainer.dataset.language || 'default';
    const endings = sentenceEndings[language] || sentenceEndings.default;
    
    // Helper function to check if word ends with any sentence ending
    const endsWithSentenceMarker = (text) => {
      return endings.some(ending => text.endsWith(ending));
    };
    
    // Find sentence boundaries
    let sentenceStart = 0; // Default to start of segment
    let sentenceEnd = allWords.length - 1; // Default to end of segment
    
    // Go backwards to find sentence start
    for (let i = wordIndex - 1; i >= 0; i--) {
      const prevWord = allWords[i].textContent.trim();
      if (endsWithSentenceMarker(prevWord)) {
        sentenceStart = i + 1;
        break;
      }
    }
    
    // Go forwards to find sentence end
    for (let i = wordIndex; i < allWords.length; i++) {
      const word = allWords[i].textContent.trim();
      if (endsWithSentenceMarker(word)) {
        sentenceEnd = i;
        break;
      }
    }
    
    
    // Ensure we have valid boundaries
    sentenceStart = Math.max(0, sentenceStart);
    sentenceEnd = Math.min(allWords.length - 1, sentenceEnd);
    
    // If no sentence boundaries found, try to find a reasonable subset
    if (sentenceStart === 0 && sentenceEnd === allWords.length - 1) {
      // Look for natural break points (commas, semicolons) near the clicked word
      const contextRadius = 15; // words around the clicked word
      sentenceStart = Math.max(0, wordIndex - contextRadius);
      sentenceEnd = Math.min(allWords.length - 1, wordIndex + contextRadius);
    }
    
    // Extract the sentence
    const sentenceWords = allWords.slice(sentenceStart, sentenceEnd + 1);
    return sentenceWords.map(w => w.textContent).join('').trim();
  }

  setActiveElement(element, translateEnabled = true, phraseSelected = false) {
    if (phraseSelected) {
      element = document.querySelector('.phrase-end')
    }

    const currentActive = document.getElementsByClassName('active');
    const hasCurrentActive = currentActive.length > 0;
    const isElementCurrentActive = hasCurrentActive && element === currentActive[0];
    const elementStartTime = element.dataset.startTime;

    if (isElementCurrentActive) {
      this.popoverService.disposePopover(currentActive[0]);
      this.playerService.play();
      return;
    }

    if (hasCurrentActive) {
      this.popoverService.disposePopover(currentActive[0]);
      this.playerService.play();
    }

    if (elementStartTime) {
      this.playerService.pause();
      this.playerService.setCurrentTime(elementStartTime);
    }

    if (element.classList.contains('unactive-sentence') || element.classList.contains('active-sentence')) {
      const activeSentence = document.querySelector('.active-sentence');
      if (activeSentence) {
        activeSentence.classList.replace('active-sentence', 'unactive-sentence');
      }
      element.classList.add('active-sentence');
    } else {
      let currentSentenceEl = element.parentNode;
      let currentSentence;

      // For word clicks, check if we need to extract a sentence from a long segment
      if (element.classList.contains('word') && !phraseSelected) {
        // Check if this is a long segment that needs sentence extraction
        const segmentText = (currentSentenceEl && currentSentenceEl.dataset && currentSentenceEl.dataset.text) || '';
        const wordCount = segmentText.split(/\s+/).length;
        
        // Only extract sentence if segment contains more than 30 words
        // This ensures we only apply it to ElevenLabs-style long segments
        if (wordCount > 30) {
          currentSentence = this.extractSentenceContainingWord(element);
        } else if (currentSentenceEl && currentSentenceEl.dataset && currentSentenceEl.dataset.text !== undefined) {
          currentSentence = currentSentenceEl.dataset.text;
        } else if (currentSentenceEl && currentSentenceEl.childNodes) {
          currentSentence = Array.from(currentSentenceEl.childNodes)
            .filter(word => word.classList && word.classList.contains('word'))
            .map(word => word.textContent)
            .join(' ');
        } else {
          currentSentence = element.textContent;
        }
      } else if (currentSentenceEl && currentSentenceEl.dataset && currentSentenceEl.dataset.text !== undefined) {
        currentSentence = currentSentenceEl.dataset.text;
      } else if (currentSentenceEl && currentSentenceEl.childNodes) {
        currentSentence = Array.from(currentSentenceEl.childNodes)
          .filter(word => word.classList && word.classList.contains('word'))
          .map(word => word.textContent)
          .join(' ');
      } else {
        currentSentence = element.textContent;
      }

      if (translateEnabled) {
        this.popoverService.showLoadingPopover(element);

        if(phraseSelected) {
          let currentPhrase = window.getSelection().toString();

          this.translationService.translateSentence(currentPhrase, (translatedData) => {
            // Callback function to execute after translation is done

            // Show the loading popover
            this.popoverService.updatePopoverContent(element, translatedData, true);
            element.classList.remove('loading');
          });
        } else {
          this.translationService.translateWord(element, currentSentence, (translatedData) => {
            // Callback function to execute after translation is done

            // Show the loading popover
            this.popoverService.updatePopoverContent(element, translatedData);
            element.classList.remove('loading');
          });
        }
      } else {
        this.playerService.togglePlayer();
      }
    }
  }
}

export default Transcript;
